import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { isLiveMap } from './withLiveMap';

export default function FitBoundsOnce({ data, fittedRef }) {
  const map = useMap();
  useEffect(() => {
    if (fittedRef?.current) return;
    if (!data?.features?.length || !isLiveMap(map)) return;
    try {
      const sampleSize = Math.min(data.features.length, 200);
      const step = Math.max(1, Math.floor(data.features.length / sampleSize));
      const sampled = { type: 'FeatureCollection', features: [] };
      for (let i = 0; i < data.features.length; i += step) {
        sampled.features.push(data.features[i]);
      }
      const bounds = L.geoJSON(sampled).getBounds();
      if (bounds.isValid()) {
        map.fitBounds(bounds, { padding: [30, 30], animate: false });
        if (fittedRef) fittedRef.current = true;
      }
    } catch (_) { /* ignore */ }
  }, [data, map, fittedRef]);
  return null;
}
